import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Link } from '@fluentui/react-components';
import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-message-bar';
import { ReactTemplate } from '@bingads-webui-react/react-template';

export const NoCompatibleGoalsWarningMessage = ({ isEditMode, onNavigateToConversionGoalsClicked }) => {
  const i18n = useContext(I18nContext);

  const template = isEditMode
    ? i18n.getString(_TL_('To add a conversion goal to this campaign, go to your conversion goals and create a new one that’s compatible with LinkedIn. {{link}}Go to your conversion goals{{/link}}'))
    : i18n.getString(_TL_('To add a conversion goal to this campaign, go to your conversion goals and create a new one that’s compatible with LinkedIn. Once your campaign is created, you can  go to your campaign settings and select the appropriate conversion goal below {{bold}}Conversions{{/bold}}. {{link}}Go to your conversion goals{{/link}}'));

  const noGoalsAvailableWarningMessage = useMemo(() => (
    <ReactTemplate
      template={template}
      model={{
        bold: text => <b>{text}</b>,
        link: text => (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link as="a" onClick={onNavigateToConversionGoalsClicked}>
            {text}
          </Link>
        ),
      }}
    />
  ), [template, onNavigateToConversionGoalsClicked]);

  return (
    <MessageBar intent="info">
      <MessageBarBody>
        <MessageBarTitle>{i18n.getString(_TL_('You haven’t yet created any conversion goals that are compatible with LinkedIn.'))}</MessageBarTitle>
        {noGoalsAvailableWarningMessage}
      </MessageBarBody>
    </MessageBar>
  );
};

NoCompatibleGoalsWarningMessage.propTypes = {
  isEditMode: PropTypes.bool,
  onNavigateToConversionGoalsClicked: PropTypes.func.isRequired,
};

NoCompatibleGoalsWarningMessage.defaultProps = {
  isEditMode: false,
};
